import { __assign, __makeTemplateObject, __rest } from "tslib";
import { noop } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import styled from '@marvelapp/styled';
import { PhishingWarning, usePhishingWarning } from '@marvelapp/ui-internal';
import Hotspot from './Hotspot';
var PositionedLink = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: ", ";\n  height: ", ";\n"], ["\n  display: block;\n  width: ", ";\n  height: ", ";\n"])), function (props) { return "".concat(props.width, "px"); }, function (props) { return "".concat(props.height, "px"); });
export default function ExternalLinkHotspot(_a) {
    var externalUrl = _a.externalUrl, newWindow = _a.newWindow, isEnterprise = _a.isEnterprise, props = __rest(_a, ["externalUrl", "newWindow", "isEnterprise"]);
    var linkProps = {
        href: externalUrl,
    };
    if (newWindow) {
        linkProps.target = '_blank';
        linkProps.rel = 'noopener noreferrer';
    }
    var _b = usePhishingWarning({
        externalUrl: externalUrl,
        isEnterprisePrototype: isEnterprise,
        newWindow: newWindow,
    }), handlePhishingWarning = _b.handlePhishingWarning, phishingProps = __rest(_b, ["handlePhishingWarning"]);
    return (React.createElement(PhishingWarning, __assign({}, phishingProps),
        React.createElement(Hotspot, __assign({ onClick: noop }, props, { x: 0, y: 0 }),
            React.createElement(PositionedLink, __assign({ id: props.id }, linkProps, props, { onClick: handlePhishingWarning })))));
}
ExternalLinkHotspot.propTypes = {
    id: PropTypes.number.isRequired,
    isEnterprise: PropTypes.bool,
    externalUrl: PropTypes.string.isRequired,
    newWindow: PropTypes.bool.isRequired,
};
var templateObject_1;
